/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { albumCollectionModelSchema } from "./albumCollectionModelSchema.ts";
import { z } from "zod";

export const albumCollectionModelPagedResultSchema = z.object({
    "totalItems": z.number().int(),
"itemsQuantity": z.number().int(),
"itemsOffset": z.number().int(),
"items": z.array(z.lazy(() => albumCollectionModelSchema))
    })